/* ================= NEW PDP WIDGET (from monavie-new-pdp.html) ================= */
(function(){
/* ================= edit here ================= */
/* Format picker and gift pictures, real product photos from assets/web */
const IMG = { shot:"//monavie.shop/cdn/shop/t/22/assets/mv-shot-box.jpg?v=92502028799063386841790702392", bottle:"//monavie.shop/cdn/shop/t/22/assets/mv-hero-bottle.png?v=174292033709511729901790702392",
              fmtShots:"//monavie.shop/cdn/shop/t/22/assets/mv-format-shots.png?v=168672558153026815121790702393", fmtBottles:"//monavie.shop/cdn/shop/t/22/assets/mv-format-bottles.png?v=137341528566974298031790702393" };
/* Social proof shown in the rating line. Set in Theme settings, MonaVie (synced below). */
const SOCIAL = { rating:4.9, reviews:0, servings:"75M+" };   /* reviews 0 = show the rating only, no count */
const GIFTS = {
  program: { value:20, label:"90 Day Vitality Program", short:"Program", pic:()=>'<img src="//monavie.shop/cdn/shop/t/22/assets/mv-gift-program.webp?v=130017920983664715761790702392" alt="90 Day Vitality Program" loading="lazy">' },
  ebook:   { value:12, label:"Keep Moving ebook", short:"Ebook", pic:()=>'<img src="//monavie.shop/cdn/shop/t/22/assets/mv-gift-ebook.webp?v=127007785108802200821790702392" alt="Keep Moving ebook" loading="lazy">' },
  ship:    { value:10, label:"Free shipping", short:"Shipping", pic:()=>'<img src="//monavie.shop/cdn/shop/t/22/assets/mv-gift-shipping.webp?v=118735020094388678511790702392" alt="Free shipping" loading="lazy">' },
};
const CHECK = {
  program:"<b>Free 90 Day Vitality Program</b>",
  ebook:"<b>Free Keep Moving ebook</b>",
  ship:"Free shipping, pause or cancel anytime"
};
const GUARANTEE = "60 day money back guarantee on your first order";
/* The offer. Pick a format, pick how many, then subscribe or buy once.
   Every subscription ships every 30 days with free shipping and all 3 welcome gifts. One time orders pay shipping.
   Shots stay at $3.00 a shot or more on every option (Gary). Bottles match monavie.shop (10% off subscribe, one time $130/$250/$360). */
let SHIP = 10;
const SUB_GIFTS = ["program","ebook","ship"];
const OFFER = {
  shots: { ask:"How many people?", unit:"shot", sizes:[
      { key:"1", label:"1 person", hint:"60 shots, 2 a day", units:"60 shots", count:60, sub:180, once:199 },
      { key:"2", label:"2 people", hint:"120 shots, 2 a day each", units:"120 shots", count:120, sub:360, once:398 } ],
    /* Launch offer. Delete this line to turn the trial off. */
    trial:{ key:"10", units:"10 shots", count:10, price:39 } },
  bottles: { ask:"How many cases?", unit:"bottle", sizes:[
      { key:"b1", label:"1 case", hint:"4 bottles", units:"4 bottles", count:4, sub:117, once:130 },
      { key:"b2", label:"2 cases", hint:"8 bottles", units:"8 bottles", count:8, sub:225, once:250 },
      { key:"b3", label:"3 cases", hint:"12 bottles", units:"12 bottles", count:12, sub:324, once:360 } ] }
};
/* Shopify ids. Filled from the store below: one variant per size, and the 30 day Seal selling plan of each variant. */
const SHOPIFY = {
  shots:   { variants:{ "1":"", "2":"", "10":"" }, plans:{} },
  bottles: { variants:{ b1:"", b2:"", b3:"" }, plans:{} }
};
const PRODUCT_ID = { shots:null, bottles:null };
/* ============================================= */

/* ---------- Shopify sync ----------
   Prices, variants and Seal selling plans come from #mv-data (snippets/mv-data.liquid), so they are
   changed in the Shopify admin. The numbers above are the approved values and only stay in use for
   a variant that does not exist yet. Variants are matched by the number in their title (60, 120, 10
   shots, 1, 2, 3 cases), falling back to their position. A variant's subscription price is the
   price of its 30 day selling plan allocation. */
const DATA = (()=>{ try { return JSON.parse(document.getElementById("mv-data").textContent) || {}; } catch(e){ return {}; } })();
const usd = n => "$" + (Math.round(n*100) % 100 ? n.toFixed(2) : Math.round(n));
const firstNum = t => { const m = /(\d+)/.exec(t||""); return m ? +m[1] : 0; };
function planDays(pl){
  const m = /(\d+)\s*-?\s*(day|week|month)/i.exec((pl.opts||"")+" "+(pl.name||""));
  if (m) return +m[1] * (/week/i.test(m[2]) ? 7 : /month/i.test(m[2]) ? 30 : 1);
  return /monthly|every month/i.test((pl.opts||"")+" "+(pl.name||"")) ? 30 : 0;   /* the live bottle plan is just "Monthly subscription" */
}
(function sync(){
  if (DATA.social){
    if (DATA.social.rating) SOCIAL.rating = DATA.social.rating;
    SOCIAL.reviews = Number(DATA.social.reviews) || 0;
    if (DATA.social.servings) SOCIAL.servings = DATA.social.servings;
  }
  if (DATA.shipFee != null && DATA.shipFee !== "") SHIP = Number(DATA.shipFee);
  ["shots","bottles"].forEach(fmt => {
    const prod = DATA[fmt]; if (!prod || !prod.variants || !prod.variants.length) return;
    PRODUCT_ID[fmt] = prod.id;
    const O = OFFER[fmt], keys = O.sizes.map(x => x.key).concat(O.trial ? [O.trial.key] : []);
    const want = { "1":60, "2":120, "10":10, b1:1, b2:2, b3:3 };
    keys.forEach((k, idx) => {
      const v = prod.variants.find(x => firstNum(x.title) === want[k]) || prod.variants[idx];
      if (!v) return;
      SHOPIFY[fmt].variants[k] = String(v.id);
      const z = O.sizes.find(x => x.key === k) || O.trial;
      if (k === "10") z.price = v.price/100; else z.once = v.price/100;
      const pl = k === "10" ? null : (v.plans.find(x => planDays(x) === 30) || null);
      if (pl){ SHOPIFY[fmt].plans[k] = String(pl.id); z.sub = pl.price/100; }
    });
  });
})();

/* Prices written into the page copy (nav, two ways cards): the lowest monthly subscription price */
function fillCopy(){
  document.querySelectorAll("[data-mv]").forEach(el => {
    const [k, fmt] = el.dataset.mv.split(":");
    if (k === "from" && OFFER[fmt]) el.textContent = usd(Math.min.apply(null, OFFER[fmt].sizes.map(x => x.sub)));
  });
}

const giftTotal = ks => ks.reduce((a,k)=>a+GIFTS[k].value,0);
const GIFT_SUM = giftTotal(SUB_GIFTS);
const giftsFor = z => SUB_GIFTS.concat(z.bonus || []);
const GIFT_NAME = { program:"90 Day Vitality Program", ebook:"Keep Moving ebook", ship:"Free shipping" };
const perUnit = (fmt, price, count) => "$"+(price/count).toFixed(2)+" a "+OFFER[fmt].unit;
const sizeOf = (fmt, i) => OFFER[fmt].sizes[i] || OFFER[fmt].sizes[0];

const GIFT_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M5 12v9h14v-9M12 8v13M12 8c-2-3-6-3-6-1s3 1 6 1c3 0 6 1 6-1s-4-2-6 1z"/></svg>';
function giftBox(z){
  const ks = giftsFor(z), bonus = ks.length > SUB_GIFTS.length;
  return '<div class="gbox"><div class="gbox-h"><b>Your free gifts</b><span>$'+GIFT_SUM+' value'+(bonus?' + bonus':'')+'</span></div><div class="gbox-i" style="grid-template-columns:repeat('+ks.length+',minmax(0,1fr))">' +
    ks.map(k=>{ const g = GIFTS[k]; return '<div class="gt'+(g.value?'':' bonus')+'"><span class="gf">'+(g.value?'Free <s>$'+g.value+'</s>':'Bonus')+'</span><div class="gp">'+g.pic()+'</div><b>'+GIFT_NAME[k]+'</b></div>'; }).join('') + '</div></div>';
}
function subCard(fmt, z, st){
  const on = st.mode === "sub", save = z.once - z.sub;
  let h = '<div class="opt subs'+(on?" on":"")+'"><div class="optrib">'+GIFT_SVG+'Best value: save $'+save+' + $'+GIFT_SUM+' in free gifts'+'</div>' +
    '<button type="button" class="opt-hd" data-a="mode" data-v="sub" role="radio" aria-checked="'+on+'"><span class="rad"></span>' +
    '<span class="opt-t"><b>Subscribe &amp; Save</b><span>'+z.units+' every 30 days'+(fmt==="shots"?', 2 a day':'')+'</span></span>' +
    '<span class="opt-p"><span class="pp"><b>$'+z.sub+'</b><s>$'+z.once+'</s></span><span>'+perUnit(fmt, z.sub, z.count)+'</span></span></button>';
  if (on){
    h += '<div class="opt-b"><ul class="ok"><li>Free shipping on every delivery</li><li>Skip, pause or cancel anytime</li><li>'+GUARANTEE+'</li></ul>' +
      '<p class="gl">Free gifts included with your first order'+'</p>' + giftBox(z) +
      '<p class="fine2">Renews at $'+z.sub+' every 30 days until you cancel.</p></div>';
  }
  return h + '</div>';
}
function onceCard(fmt, z, st){
  const on = st.mode === "once";
  let h = '<div class="opt once2'+(on?" on":"")+'"><button type="button" class="opt-hd" data-a="mode" data-v="once" role="radio" aria-checked="'+on+'"><span class="rad"></span>' +
    '<span class="opt-t"><b>One Time Purchase</b><span>'+z.units+' delivered once'+(fmt==="shots"?', 2 a day':'')+'</span></span>' +
    '<span class="opt-p"><span class="pp"><b>$'+z.once+'</b></span><span>+ $'+SHIP+' shipping</span></span></button>';
  if (on){
    h += '<div class="nudge"><div class="nudge-top"><div class="nudge-imgs">'+giftsFor(z).map(k=>'<span>'+GIFTS[k].pic()+'</span>').join('')+'</div>' +
      '<div><b>You\'re missing $'+GIFT_SUM+' in free gifts'+'</b><span>Subscribe to save $'+(z.once-z.sub)+' and get free shipping, the program and the ebook.</span></div></div>' +
      '<button type="button" class="nudge-btn" data-a="mode" data-v="sub">Switch to Subscribe &amp; Save</button></div>';
  }
  return h + '</div>';
}
function trialCard(fmt, st){
  const T = OFFER[fmt].trial; if (!T) return "";
  const on = st.mode === "trial";
  return '<div class="opt trial'+(on?" on":"")+'"><span class="ltag"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l2.4 5.6L20 9.3l-4.3 3.9 1.2 5.8L12 16.1 7.1 19l1.2-5.8L4 9.3l5.6-.7z"/></svg>Limited time launch offer</span>' +
    '<button type="button" class="opt-hd" data-a="mode" data-v="trial" role="radio" aria-checked="'+on+'"><span class="rad"></span><span class="tthumb"><img src="//monavie.shop/cdn/shop/t/22/assets/mv-trial-box.webp?v=5215134555270523091791313014" alt="MonaVie Active 10 shot box"></span>' +
    '<span class="opt-t"><b>Try '+T.units+'</b><span>New to MonaVie? One time, no subscription</span></span>' +
    '<span class="opt-p"><span class="pp"><b>$'+T.price+'</b></span><span>+ $'+SHIP+' shipping</span></span></button></div>';
}

function render(st){
  const fmt = st.fmt, O = OFFER[fmt], zi = st.size[fmt], z = sizeOf(fmt, zi);
  let h = '<div class="w im">';
  h += '<div class="lbl"><b>Choose your format</b></div><div class="fmts">' +
    '<button class="fmt'+(fmt==="shots"?" on":"")+'" data-a="fmt" data-v="shots" aria-pressed="'+(fmt==="shots")+'"><span class="new">New</span><img class="fmtimg" src="'+IMG.fmtShots+'" alt="Three MonaVie 2 oz shots"><span><b>Shots</b><span>2 oz, 2 a day</span></span></button>' +
    '<button class="fmt'+(fmt==="bottles"?" on":"")+'" data-a="fmt" data-v="bottles" aria-pressed="'+(fmt==="bottles")+'"><img class="fmtimg" src="'+IMG.fmtBottles+'" alt="Two MonaVie 25 oz bottles"><span><b>Bottles</b><span>25 oz each</span></span></button></div>';
  h += '<div class="lbl"><b>'+O.ask+'</b></div><div class="howmany" role="radiogroup" aria-label="'+O.ask+'" style="grid-template-columns:repeat('+O.sizes.length+',minmax(0,1fr))">' +
    O.sizes.map((x,i)=>{ const on = i===zi && st.mode!=="trial"; return '<button type="button" role="radio" aria-checked="'+on+'" class="osz'+(on?' on':'')+'" data-a="size" data-v="'+i+'">'+(x.badge?'<em class="hm-badge">'+x.badge+'</em>':'')+'<b>'+x.label+'</b><span>'+x.hint+'</span></button>'; }).join('') + '</div>';
  h += '<div class="lbl"><b>Choose your plan</b></div><div class="opts" role="radiogroup" aria-label="Choose your plan">' + subCard(fmt, z, st) + onceCard(fmt, z, st) + trialCard(fmt, st) + '</div>';
  
  h += '<button class="cta" data-a="cta">Add to cart</button>';
  h += '<div class="badges">' +
    '<div><span class="ic"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2F5A3A" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z"/></svg></span>60 day money back, first order</div>' +
    '<div><span class="ic"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#2F5A3A" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 6.5h11v9h-11zM13.5 9.5h4l3 3v3h-7"/><circle cx="6.5" cy="17" r="1.8"/><circle cx="17" cy="17" r="1.8"/></svg></span>Free shipping</div>' +
    '<div><span class="ic"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2F5A3A" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M10 9v6M14 9v6"/></svg></span>Cancel anytime</div></div>';
  return h + '</div>';
}

const TITLE = { shots:"MonaVie Active, Shots", bottles:"MonaVie Active, Bottles" };
const FMT_NAME = { shots:"Shots", bottles:"Bottles" };

/* Cart lines for a selection. lines(format, size index, mode) where mode is "sub", "once" or "trial". */
const GIFT_IMG = { program:"//monavie.shop/cdn/shop/t/22/assets/mv-gift-program.webp?v=130017920983664715761790702392", ebook:"//monavie.shop/cdn/shop/t/22/assets/mv-gift-ebook.webp?v=127007785108802200821790702392", ship:"//monavie.shop/cdn/shop/t/22/assets/mv-gift-shipping.webp?v=118735020094388678511790702392" };
function lines(fmt, sizeIdx, mode){
  if (mode === true) mode = "once"; if (!mode) mode = "sub";
  const img = fmt==="shots" ? IMG.fmtShots : IMG.fmtBottles, S = SHOPIFY[fmt];
  if (mode === "trial" && OFFER[fmt].trial){
    const T = OFFER[fmt].trial;
    return [{ key:fmt+"|once|trial", fmt, productId:PRODUCT_ID[fmt], once:true, title:TITLE[fmt], detail:"Trial, "+T.units, planLabel:"One time purchase",
      unit:T.price, was:T.price, qty:1, img, freeShip:false, shipFee:SHIP, variant:S.variants[T.key], sellingPlan:"",
      properties:{ "Format":FMT_NAME[fmt], "Plan":"Trial, "+T.units, "Purchase type":"One time purchase" },
      upgrade:{ label:"Subscribe instead", fmt, plan:0 } }];
  }
  const z = sizeOf(fmt, sizeIdx), i = OFFER[fmt].sizes.indexOf(z);
  if (mode === "once"){
    return [{ key:fmt+"|once|"+z.key, fmt, productId:PRODUCT_ID[fmt], once:true, title:TITLE[fmt], detail:(fmt==="bottles"?z.label+", ":"")+z.units, planLabel:"One time purchase",
      unit:z.once, was:z.once, qty:1, img, freeShip:false, shipFee:SHIP, variant:S.variants[z.key], sellingPlan:"",
      properties:{ "Format":FMT_NAME[fmt], "Plan":"One time, "+z.label+", "+z.units, "Purchase type":"One time purchase" },
      upgrade:{ label:"Subscribe instead", fmt, plan:i } }];
  }
  const key = fmt+"|sub|"+z.key;
  const out = [{ key, fmt, productId:PRODUCT_ID[fmt], title:TITLE[fmt], detail:(fmt==="bottles"?z.label+", ":"")+z.units+" every 30 days", planLabel:"Subscription · every 30 days",
    unit:z.sub, was:z.once, qty:1, img, freeShip:true, shipFee:0, variant:S.variants[z.key], sellingPlan:S.plans[z.key] || "",
    properties:{ "Format":FMT_NAME[fmt], "Plan":z.label+", "+z.units, "Purchase type":"Subscription", "Delivers every":"30 days" } }];
  giftsFor(z).forEach(k => {
    const det = k==="ship" ? "On every delivery" : k==="ebook" ? "Instant download after checkout" : "Sent by email after checkout";
    out.push({ key:key+"|"+k, parent:key, gift:true, info:true, title:GIFTS[k].label, detail:det, unit:0, was:GIFTS[k].value, qty:1, img:GIFT_IMG[k] });
  });
  return out;
}

/* /cart.js items back to the drawer lines the preview shows. The gift rows are display only:
   program, ebook and free shipping, each once, for any subscription in the cart. */
function matchLine(i){
  const vid = String(i.variant_id), sub = !!i.selling_plan_allocation;
  for (const fmt of ["shots","bottles"]){
    const V = SHOPIFY[fmt].variants;
    for (const k of Object.keys(V)){
      if (V[k] !== vid) continue;
      if (k === "10") return { fmt, idx:0, mode:"trial" };
      return { fmt, idx:OFFER[fmt].sizes.findIndex(x => x.key === k), mode:sub ? "sub" : "once" };
    }
  }
  return null;
}
window.MVPDP = {
  lines,
  get hasWidget(){ return !!document.getElementById("widget"); },
  fromCart(items){
    const out = [], giftSeen = {}; let subs = 0;
    items.forEach(i => {
      const m = matchLine(i), unit = i.final_price/100;
      if (!m){
        const sp = i.selling_plan_allocation;
        out.push({ key:i.key, title:i.product_title, detail:i.variant_title||"", planLabel: sp ? "Subscription · "+sp.selling_plan.name : "One time purchase",
          unit, was:Math.max(unit, i.original_price/100), qty:i.quantity, img:i.image, freeShip:false, shipFee:0 });
        return;
      }
      const tpl = lines(m.fmt, m.idx, m.mode);
      out.push(Object.assign({}, tpl[0], { key:i.key, qty:i.quantity, unit, was:Math.max(tpl[0].was, i.original_price/100) }));
      if (m.mode === "sub") subs++;
    });
    if (subs){
      lines("shots", 0, "sub").slice(1).forEach(g => { if (giftSeen[g.title]) return; giftSeen[g.title] = 1; out.push(Object.assign({}, g, { key:"gift|"+g.title, parent:out[0].key })); });
    }
    return out;
  },
  giftFixes(){ return null; },   /* no gift product lines any more, the gifts are display rows */
  upgradeInfo(fmt, plan){
    const z = sizeOf(fmt, plan || 0);
    return { name:"subscription", imgs:giftsFor(z).map(k=>GIFT_IMG[k]),
      pitch:"Save $"+(z.once-z.sub)+" and get "+SUB_GIFTS.length+" free gifts worth $"+GIFT_SUM };
  },
  pick(fmt, plan){
    if (!document.getElementById("widget")) return;
    if (OFFER[fmt]) st.fmt = fmt;
    if (plan === "sub") st.mode = "sub";
    draw();
  }
};

fillCopy();

/* ---------- PDP wiring ---------- */
const st = { fmt:DATA.defaultFormat === "bottles" ? "bottles" : "shots", size:{ shots:0, bottles:0 }, mode:"sub", last:null };   /* Subscribe and save selected on load */
const stage = document.getElementById("widget");
if (!stage) return;
const rating = document.getElementById("pdp-rating");
if (rating) rating.innerHTML = '<a class="rlink" href="#reviews"><span class="stars" aria-label="'+SOCIAL.rating+' out of 5 stars">★★★★★</span><b>'+SOCIAL.rating+'/5</b>'+(SOCIAL.reviews?'<span class="rcount">'+SOCIAL.reviews.toLocaleString("en-US")+' reviews</span>':'')+'<span class="sep"></span><span>'+SOCIAL.servings+' servings sold</span></a>';

function draw(){
  if (st.mode === "trial" && !OFFER[st.fmt].trial) st.mode = "sub";
  stage.innerHTML = render(st);
  const z = sizeOf(st.fmt, st.size[st.fmt]), T = OFFER[st.fmt].trial;
  document.body.setAttribute("data-format", st.fmt);  /* swaps the main gallery photo between shots and bottles */
  const $id = x => document.getElementById(x);
  $id("sImg").src = st.fmt==="shots" ? IMG.fmtShots : IMG.fmtBottles;
  $id("sRate").textContent = SOCIAL.reviews ? SOCIAL.rating+" ("+SOCIAL.reviews.toLocaleString("en-US")+")" : SOCIAL.rating+"/5";
  document.querySelector("#sticky .sk-trust span").hidden = st.mode !== "sub";
  if (st.mode === "trial"){
    $id("sName").textContent = FMT_NAME[st.fmt]+", trial "+T.units;
    $id("sPrice").textContent = "$"+T.price; $id("sWas").textContent = ""; $id("sPerk").textContent = "+ $"+SHIP+" shipping"; $id("sAmt").textContent = "$"+T.price;
  } else if (st.mode === "once"){
    $id("sName").textContent = FMT_NAME[st.fmt]+", "+z.label+", one time";
    $id("sPrice").textContent = "$"+z.once; $id("sWas").textContent = ""; $id("sPerk").textContent = "+ $"+SHIP+" shipping"; $id("sAmt").textContent = "$"+z.once;
  } else {
    $id("sName").textContent = FMT_NAME[st.fmt]+", "+z.label;
    $id("sPrice").textContent = "$"+z.sub+"/mo"; $id("sWas").textContent = "$"+z.once; $id("sPerk").textContent = SUB_GIFTS.length+" free gifts"; $id("sAmt").textContent = "$"+z.sub;
  }
}

let busy = false;
function addToCart(btn){
  if (busy || !window.MVCart) return;
  busy = true;
  const sBtn = document.getElementById("sBtn"), cta = stage.querySelector(".cta");
  [btn, sBtn, cta].forEach(b => { if (b) b.disabled = true; });
  const old = stage.querySelector(".err"); if (old) old.remove();
  let p;
  try { p = window.MVCart.add(lines(st.fmt, st.size[st.fmt], st.mode)); } catch(e){ p = Promise.reject(e); }
  p.catch(err => {
    console.error(err);
    const c = stage.querySelector(".cta");
    if (c) c.insertAdjacentHTML("afterend", '<p class="err" role="alert">Something went wrong adding this to your cart. Please try again.</p>');
  }).then(() => { busy = false; [sBtn, stage.querySelector(".cta")].forEach(b => { if (b) b.disabled = false; }); });
}

stage.addEventListener("click", e => {
  const b = e.target.closest("[data-a]"); if (!b) return;
  const a = b.dataset.a;
  if (a === "fmt") st.fmt = b.dataset.v;
  else if (a === "size"){ st.size[st.fmt] = +b.dataset.v; if (st.mode === "trial") st.mode = "sub"; }
  else if (a === "mode") st.mode = b.dataset.v;
  else if (a === "cta"){ addToCart(b); return; }
  draw();
});

/* Deep links for email and ads
   ?format=shots | bottles     ?plan=sub | once | trial     ?size=1 | 2 (people, shots) or b1 | b2 | b3 (cases)
   older links still work: ?plan=monthly, 1m, 2m, 90d (subscribe), ?plan=try or starter or ?size=10 (trial), ?supply=s60, b1, b2, b3 */
(function(){
  const q = new URLSearchParams(location.search);
  const f = q.get("format"), s = q.get("supply"), p = q.get("plan"), sz = q.get("size") || q.get("people");
  if (f && OFFER[f]) st.fmt = f;
  const sup = { s30:["shots",0], s60:["shots",0], s120:["shots",1], s180:["shots",1], b1:["bottles",0], b2:["bottles",1], b3:["bottles",2] };
  if (s && sup[s]){ st.fmt = sup[s][0]; st.size[st.fmt] = sup[s][1]; }
  if (p === "once") st.mode = "once";
  else if (p === "trial" || p === "try" || p === "starter") st.mode = "trial";
  if (sz){
    if (sz === "10") st.mode = "trial";
    else {
      const alias = { "60":"1", "120":"2", "30":"1", "1c":"b1", "2c":"b2", "3c":"b3" }, k = alias[sz] || sz;
      ["shots","bottles"].forEach(fm => { const i = OFFER[fm].sizes.findIndex(x => x.key === k); if (i > -1){ st.fmt = fm; st.size[fm] = i; } });
    }
  }
  draw();
  if (f || s || p || sz) setTimeout(() => { const b = document.getElementById("buy"); if (b) b.scrollIntoView(); }, 60);
})();

fillCopy();
/* Other links on the page (nav, hero, section buttons) pick a format here */
const sticky = document.getElementById("sticky");
document.getElementById("sBtn").addEventListener("click", e => addToCart(e.currentTarget));
function checkSticky(){
  const c = stage.querySelector(".cta"); if (!c) return;
  const show = c.getBoundingClientRect().bottom < 0;
  sticky.classList.toggle("show", show); sticky.setAttribute("aria-hidden", String(!show));
}
window.addEventListener("scroll", checkSticky, { passive:true }); window.addEventListener("resize", checkSticky);
checkSticky();
})();
